// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3eeWY","notes":"Notes_notes__17pu5"};